import DIApi from './_diApi';

class CurrencyAPI extends DIApi {
  controllerName = 'Currencys';
}

export default new CurrencyAPI();
